export const selectTopicInfo = state => state.existingMaterial;
